import { useTranslation } from 'react-i18next';
import { upperCase } from 'lodash';
import Panel from '../../components/Panel/Panel';
import { Spaced } from '../../components/Spaced/Spaced';
import CompleteOrderButton from './CompleteOrderButton';
import { Discounts, Subtotal, Total } from './Total';
import SummaryPanelLoading from './SummaryPanelLoading';

function SummaryPanel() {
  const { t } = useTranslation();

  return (
    <Panel title={upperCase(t('summary'))} loadingComponent={<SummaryPanelLoading />}>
      <Spaced size="medium">
        <Subtotal />
        <Discounts />
        <Total textType="bold" />
      </Spaced>
      <CompleteOrderButton />
    </Panel>
  );
}

export default SummaryPanel;
